import React from "react";
import {
  TableContainer,
  SkeletonContainer,
  SkeletonRow,
  SkeletonCell,
  NoDataContainer,
  NoDataIcon,
  NoDataText,
  NoDataSubtext,
} from "./index.styled";
import viewIcon from "../../../../assets/icons/view.webp";
import userGreenIcon from "../../../../assets/icons/user-green.webp";
import conversionRateIcon from "../../../../assets/icons/conversionRate.webp";
import StarIcon from "../../StarIcon";
import LoadingSpinner from "../../../shared/LoadingSpinner";

interface SubscriptionDataItem {
  source: string;
  views: number;
  addedUsers: number;
  conversionRate: number;
  color: string;
}

interface SubscriptionDataTableProps {
  data: SubscriptionDataItem[];
  loading?: boolean;
  isLoading?: boolean;
}

const SubscriptionDataTable: React.FC<SubscriptionDataTableProps> = ({
  data,
  loading = false,
  isLoading = false,
}) => {
  if (loading) {
    return (
      <TableContainer>
        <SkeletonContainer>
          <table>
            <thead>
              <tr>
                <th></th>
                <th>
                  <img className="header-icon" src={viewIcon} alt="View" />
                </th>
                <th>
                  <img
                    className="header-icon"
                    src={userGreenIcon}
                    alt="Users"
                  />
                </th>
                <th>
                  <img
                    className="header-icon"
                    src={conversionRateIcon}
                    alt="Conversion Rate"
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              {Array.from({ length: 5 }).map((_, index) => (
                <SkeletonRow key={index} $delay={index * 0.1}>
                  <td>
                    <SkeletonCell $width="80px" $height="20px" />
                  </td>
                  <td>
                    <SkeletonCell $width="60px" $height="16px" />
                  </td>
                  <td>
                    <SkeletonCell $width="60px" $height="16px" />
                  </td>
                  <td>
                    <SkeletonCell $width="40px" $height="16px" />
                  </td>
                </SkeletonRow>
              ))}
            </tbody>
          </table>
        </SkeletonContainer>
      </TableContainer>
    );
  }

  if (isLoading) {
    return (
      <NoDataContainer>
        <NoDataIcon>
          <LoadingSpinner />
        </NoDataIcon>
        <NoDataText>טוען את המידע של הפילוח...</NoDataText>
        <NoDataSubtext>אנא המתן, המידע נטען</NoDataSubtext>
      </NoDataContainer>
    );
  }

  if (!data || data.length === 0) {
    return (
      <NoDataContainer>
        <NoDataIcon>
          <StarIcon size={72} color="#122243" filled={true} />
        </NoDataIcon>
        <NoDataText>אין עדיין את המידע של הפילוח</NoDataText>
        <NoDataSubtext>המידע יופיע כאן ברגע שיהיה זמין</NoDataSubtext>
      </NoDataContainer>
    );
  }

  return (
    <TableContainer>
      <table>
        <thead>
          <tr>
            <th></th>
            <th>
              <img className="header-icon" src={viewIcon} alt="View" />
            </th>
            <th>
              <img className="header-icon" src={userGreenIcon} alt="Users" />
            </th>
            <th>
              <img
                className="header-icon"
                src={conversionRateIcon}
                alt="Conversion Rate"
              />
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              <td>
                <div className="table-cell source-cell">
                  <div
                    className="color-indicator"
                    style={{ backgroundColor: item.color }}
                  />
                  <span>{item.source}</span>
                </div>
              </td>
              <td>
                <div className="table-cell">{item.views.toLocaleString()}</div>
              </td>
              <td>
                <div className="table-cell">
                  {item.addedUsers.toLocaleString()}
                </div>
              </td>
              <td>
                <div className="table-cell">
                  {Math.round(item.conversionRate)}%
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </TableContainer>
  );
};

export default SubscriptionDataTable;
